import { FC } from "react";

import { serverCreateImpersonationUrl } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { LoadingDotsIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentUserId } from "store/selectors";
import { usePromiseEffect } from "store/store-hooks";
import { pathToImpersonationUrl } from "utils/user-utils";

export const MobileLoginModal: FC = () => {
  const currentUserId = useAppSelector(selectCurrentUserId);

  const {
    isLoading,
    error,
    data: redemptionUrl,
  } = usePromiseEffect(() => serverCreateImpersonationUrl(currentUserId), [currentUserId]);

  const link = redemptionUrl ? pathToImpersonationUrl(redemptionUrl) : "";

  if (error) {
    return (
      <div className="mobile-login-modal px-6 pb-6">
        <h3 className="my-2">{t("profile_panel.log_in_with_mobile_device_error", { error })}</h3>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="mobile-login-modal px-6 pb-6">
        <LoadingDotsIcon />
      </div>
    );
  }

  return (
    <div className="mobile-login-modal flex max-w-md flex-col items-start">
      <div className="body-s mb-6">{t("profile_panel.log_in_with_mobile_device_warning")}</div>

      <div className="my-3 mb-6 flex w-full justify-center">
        <img
          alt="QR code for mobile login"
          className="mobile-login-qr-code"
          src={`https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${encodeURIComponent(link)}`}
        />
      </div>
    </div>
  );
};
